import { render, staticRenderFns } from "./filesComponent.vue?vue&type=template&id=632894ce&"
import script from "./filesComponent.vue?vue&type=script&lang=js&"
export * from "./filesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports